module.exports = __webpack_public_path__ + "img/dataPdf2.8811c9ad.png";